import { atom, useAtom } from 'jotai';

const sessionAtom = atom<{ companyId?: string }>({});

export function useSession() {
  return useAtom(sessionAtom);
}
